import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { ANNOUNCEMENT_STATUSES } from "../../constants";
import { AnnouncementStatus } from "../../types";

interface AnnouncementModalFooterProps {
    isFormIncomplete: boolean;
    isLoading: boolean;
    announcementStatus?: AnnouncementStatus;
    onClickClose: () => void;
    onSaveDraft: () => void;
    onActivate: () => void;
}

const AnnouncementModalFooter = (props: AnnouncementModalFooterProps) => {
    const {
        isFormIncomplete,
        isLoading,
        announcementStatus,
        onClickClose,
        onSaveDraft,
        onActivate,
    } = props;

    const { t } = useTranslation(["common", "announcements"]);

    const isActiveOrLive =
        announcementStatus === ANNOUNCEMENT_STATUSES.ACTIVE ||
        announcementStatus === ANNOUNCEMENT_STATUSES.LIVE;

    return (
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 w-full">
            <div className="flex flex-col sm:flex-row gap-2 shrink-0 sm:ml-auto [&>button]:w-full sm:[&>button]:w-auto">
                <Button
                    onClick={onClickClose}
                    text
                    severity="secondary"
                    disabled={isLoading}
                    label={t("common:cancel")}
                />
                <Button
                    onClick={onSaveDraft}
                    severity="secondary"
                    disabled={isFormIncomplete || isLoading}
                    loading={isLoading}
                    label={t(isActiveOrLive ? "announcements:modal.deactivate" : "announcements:modal.draft")}
                />
                <Button
                    onClick={onActivate}
                    severity="success"
                    disabled={isFormIncomplete || isLoading}
                    loading={isLoading}
                    label={t(isActiveOrLive ? "announcements:modal.update" : "announcements:modal.active")}
                />
            </div>
        </div>
    );
};

export default AnnouncementModalFooter;
